"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.MailTemplateEnum = void 0;
var MailTemplateEnum;
(function (MailTemplateEnum) {
    MailTemplateEnum["AccountActivation"] = "account-activation";
    MailTemplateEnum["EmailVerification"] = "email-verification";
    MailTemplateEnum["ResetPassword"] = "reset-password";
    MailTemplateEnum["PeriodicReport"] = "periodic-report";
    MailTemplateEnum["PriceAlert"] = "price-alert";
    MailTemplateEnum["CancelSubscription"] = "cancel-subscription";
    MailTemplateEnum["DeletedAccount"] = "deleted-account";
    MailTemplateEnum["ReferralRegistration"] = "referral-registration";
    MailTemplateEnum["ReferralPending"] = "referral-pending";
    MailTemplateEnum["ReferralAvailable"] = "referral-available";
    MailTemplateEnum["MagicLink"] = "magic-link";
    MailTemplateEnum["Header"] = "header";
    MailTemplateEnum["Footer"] = "footer";
})(MailTemplateEnum = exports.MailTemplateEnum || (exports.MailTemplateEnum = {}));
//# sourceMappingURL=mail-template-enum.js.map